import toast from 'react-hot-toast';
import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const usePatchUserProfileMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: unknown) => void;
  } = { onSuccess: () => {} }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      firstName,
      lastName,
    }: {
      userId: string | undefined;
      firstName: string;
      lastName: string;
    }) => {
      const patchPromise = client.patch(`/users/${userId}`, {
        firstName,
        lastName,
      });

      const { data } = await toast.promise(patchPromise, {
        loading: 'Updating profile...',
        success: 'Profile updated successfully',
        error: (error) => {
          if (axios.isAxiosError(error)) {
            return error?.response?.data?.message || 'Failed to update profile';
          }
          return error instanceof Error ? error.message : 'Failed to update profile';
        },
      });

      return data.body;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['auth', 'session'],
      });
    },
  });
};
